<template>
	<div class="createSmallInstitution">
		<init-header
			class="init-header"
			:goBack="prev"
			:removeClose="true"
			:disabled="progressStep > 1 ? false : true"
			style="width: calc(100% + 40px); margin-left: -20px"
		></init-header>
		<progress-question
			:progressStep="progressStep"
			:groupName="createParams.groupName"
		></progress-question>
		<progress-input-step1
			v-if="progressStep === 1"
			v-model="createParams.instituteName"
			:placeholder="tt(placeholder)"
			:validText="tt(validText)"
			:isValid="isValid"
		></progress-input-step1>
		<progress-input-step2
			v-else-if="progressStep === 2"
			v-model="createParams.groupName"
			:placeholder="tt(placeholder)"
			:validText="tt(validText)"
			:isValid="isValid"
		></progress-input-step2>
		<progress-input-step3
			v-else-if="progressStep === 3"
			:storagesName="createParams.storagesName"
			@updateStorage="updateStorage"
			@clickDeleteStorage="clickDeleteStorage"
			:placeholder="tt(placeholder)"
		></progress-input-step3>
		<!-- <progress-input-step4
			v-else-if="progressStep === 4"
			:instituteId="instituteId"
			:groupId="groupId"
		></progress-input-step4> -->
		<button class="next" @click="next">{{ tt(nextBtn) }}</button>
	</div>
</template>

<script>
import axios from '@/services/axiosConfig'
import instituteCreateAPI from '@/services/api/institute/create'
import instituteInformationAPI from '@/services/api/institute/information'
import instituteGroupAPI from '@/services/api/institute/group'
import instituteStorageAPI from '@/services/api/institute/storage'
import locationAPI from '@/services/api/institute/location'
import InitHeader from '@/views/common/components/InitHeader.vue'
import ProgressQuestion from '@/views/create/components/ProgressQuestion.vue'
import ProgressInput from '@/views/create/components/ProgressInput.vue'
import ProgressInputStorage from '@/views/create/components/ProgressInputStorage.vue'
import ProgressInputInvite from '@/views/create/components/ProgressInputInvite.vue'
export default {
	name: 'CreateSmallInstitution',
	components: {
		InitHeader,
		ProgressQuestion,
		'progress-input-step1': ProgressInput,
		'progress-input-step2': ProgressInput,
		'progress-input-step3': ProgressInputStorage,
		'progress-input-step4': ProgressInputInvite,
	},
	data() {
		return {
			progressStep: 1,
			createParams: {
				instituteName: '',
				groupName: '',
				storagesName: [''],
			},
			originalParams: {
				instituteName: '',
				groupName: '',
				storagesName: [],
			},
			placeholder: '기관명',
			validText: '기관명을 입력해주세요',
			isValid: true,
			instituteId: '',
			groupId: '',
			groupLocationId: '',
			isModify: false,
		}
	},
	watch: {
		progressStep: {
			handler(value) {
				if (value === 1) {
					this.placeholder = '기관명'
				} else if (value === 2) {
					this.placeholder = '그룹 이름'
				} else if (value === 3) {
					this.placeholder = '보관함 이름'
				}
			},
		},
	},
	computed: {
		nextBtn() {
			if (this.progressStep == 3) {
				return '랩매니저 시작하기'
			} else {
				return '다음'
			}
		},
	},
	methods: {
		async next() {
			switch (this.progressStep) {
				case 1:
					if (!this.createParams.instituteName) {
						this.validText = '기관명을 입력해주세요'
						this.isValid = false
						return false
					}
					break
				case 2:
					if (!this.createParams.groupName) {
						this.validText = '그룹명을 입력해주세요'
						this.isValid = false
						return false
					}
					break
				case 3:
					if (this.createParams.storagesName[0] === '') {
						this.createParams.storagesName.splice(0, 1, '보관함')
						this.createParams.storagesName.push('')
					}
					this.createParams.storagesName.pop()
					if (this.isModify) {
						await this.updateCreateParams()
					} else {
						await this.createInst()
					}
					// 	break
					// case 4:
					this.$router.push({
						name: 'Dashboard',
						params: {
							instituteId: this.instituteId,
						},
					})
					return false
			}
			this.isValid = true
			this.progressStep += 1
		},
		prev() {
			if (this.progressStep === 3) {
				this.createParams.storagesName.push('')
				this.originalParams = JSON.parse(
					JSON.stringify(this.createParams)
				)
				this.isModify = true
			}
			this.progressStep -= 1
		},
		async createInst() {
			const response = await instituteCreateAPI.createInstitute(
				this.createParams
			)
			response?.data?.instituteId
				? (this.instituteId = response.data.instituteId)
				: (this.instituteId = '')
			response?.data?.groupId
				? (this.groupId = response.data.groupId)
				: (this.groupId = '')
			response?.data?.groupLocationId
				? (this.groupLocationId = response.data.groupLocationId)
				: (this.groupLocationId = '')
		},
		async updateCreateParams() {
			const formData = new FormData()
			const addStorages = this.getChangedStorages(
				this.createParams.storagesName,
				this.originalParams.storagesName
			)
			const deleteStorages = this.getChangedStorages(
				this.originalParams.storagesName,
				this.createParams.storagesName
			)

			let locationId = ''
			let deleteStorageIdList = []
			await instituteStorageAPI
				.lookupRootStorageList(this.instituteId)
				.then(result => {
					result.data.forEach(storage => {
						if (deleteStorages.includes(storage.name)) {
							deleteStorageIdList.push(storage.id)
						}
						if (storage.locationId != this.groupLocationId)
							locationId = storage.locationId
					})
				})

			if (addStorages && addStorages.length > 0) {
				addStorages.forEach(storage => {
					instituteStorageAPI.createStorage(this.instituteId, {
						name: storage,
						assigneeGroupId: this.groupId,
						locationId: this.groupLocationId,
					})
				})
			}

			if (deleteStorages && deleteStorages.length > 0) {
				deleteStorageIdList.forEach(id => {
					instituteStorageAPI.deleteStroage(this.instituteId, id)
				})
			}

			if (
				this.originalParams.instituteName !=
				this.createParams.instituteName
			) {
				formData.append('name', this.createParams.instituteName)
				await instituteInformationAPI.editInstInfo(
					this.instituteId,
					formData
				)
				await locationAPI.updateLocation(this.instituteId, {
					id: locationId,
					name: this.createParams.instituteName,
				})
			}
			if (this.originalParams.groupName != this.createParams.groupName) {
				await instituteGroupAPI.editGroup(this.groupId, {
					name: this.createParams.groupName,
				})
				await locationAPI.updateLocation(this.instituteId, {
					id: this.groupLocationId,
					name: this.createParams.groupName,
				})
			}
		},
		getChangedStorages(target, value) {
			const arr = []
			target.forEach(storage => {
				if (!value.includes(storage)) {
					arr.push(storage)
				}
			})
			return arr
		},
		updateStorage(index, storage) {
			if (
				storage.length === 1 &&
				this.createParams.storagesName[index + 1] === undefined
			) {
				this.createParams.storagesName.push('')
			}
		},
		clickDeleteStorage(index) {
			this.createParams.storagesName.splice(index, 1)
		},
	},
}
</script>

<style lang="scss" scoped>
.createSmallInstitution {
	width: 100%;
	padding: 0 20px;
	position: relative;
	.next {
		width: 100%;
		height: 48px;
		border-radius: 8px;
		background-color: #fec741;
		font-size: 1rem;
		font-weight: 700;
		display: flex;
		align-items: center;
		justify-content: center;
		margin-top: 20px;
		margin-bottom: 80px;
	}
	// .startLab{
	//     top: 90%;
	// }
	.init-header {
		position: sticky;
		width: 100%;
		top: 0;
		left: 0;
		z-index: 10;
	}
}
</style>
